import cls from "classnames";

const ButtonWrapper = ({ step, children, isSinglePage }) => {
  return (
    <div
      className={cls(
        `flex flex-row items-center w-full max-w-[420px]`,
        step > 0 && !isSinglePage ? "justify-between" : "justify-end"
      )}
    >
      {children}
    </div>
  );
};

export default ButtonWrapper;
